import { useState, useEffect } from "react";

const usePlaylistAddForm = (initialFormValues, callback) => {
  const [inputs, setInputs] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors]);

  function validateTitle(values) {
    let errors = {};
    if (!values.playlistName || values.playlistName.trim() === "") {
      errors.subject = "Please enter a name for your new playlist.";
    }
    return errors;
  }
  function validatePlaylist(values) {
    let errors = {};
    if (!values || Object.keys(values).length === 0 || values["existingPlaylist"] === undefined) {
      errors.subject = "Please select an existing playlist from the dropdown.";
    }
    return errors;
  }

  const handleInputChange = (event) => {
    console.log("🚀 ~ file: usePlaylistAddForm.js:32 ~ handleInputChange ~ event:", event);
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };

  const handleSelectChange = (name, value) => {
    // event.persist();
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const clearForm = () => {
    setInputs(initialFormValues);
  };

  const handleSubmitTitle = (event) => {
    if (event) event.preventDefault();
    setErrors(validateTitle(inputs));
    const { existingPlaylist, ...restOfInputs } = inputs;
    setInputs(restOfInputs);
    setIsSubmitting(true);
  };
  const handleSubmitPlaylist = (event) => {
    if (event) event.preventDefault();
    setErrors(validatePlaylist(inputs));
    const { playlistName, ...restOfInputs } = inputs;
    setInputs(restOfInputs);
    setIsSubmitting(true);
  };

  return {
    handleInputChange,
    handleSelectChange,
    handleSubmitTitle,
    handleSubmitPlaylist,
    inputs,
    clearForm,
    errors,
  };
};

export default usePlaylistAddForm;
